import React, { useState } from "react";
import { Container } from "../../../DistributionComponents/common/Container";
import { GridRow } from "../../../DistributionComponents/common/GridRow";
import { Message } from "../../../foundation/Message/Message";
import { GridCell } from "../../../DistributionComponents/common/GridCell";
import { Card } from "../../../foundation/Card";
import logo from "../../../assets/logo-icon.png";
import "./Forgotpassword.css";
import { SpinnerButton } from "../../../foundation/Button";
import notifyToast from "../../../foundation/Toast/Toast";
import { MESSAGES } from "../../../constants/constants";
const forgotPassword = () => {
  const [message, setMessage] = useState("");
  const [isSpinning, setIsSpinning] = useState(false);
  const [email, setEmail] = useState("");
  const submitText = "Reset Password";
  const handleChange = (e) => {
    setMessage({});
    setEmail(e.target.value);
  };
  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  const handleForgotPassword = async () => {
    if (!email) {
      setMessage({ type: MESSAGES.ERROR, text: "email cannot be empty" });
      return;
    }
    if (!validateEmail(email)) {
      setMessage({ type: MESSAGES.ERROR, text: "not a valid email address" });
      return;
    }
    try {
      setIsSpinning(true);
      const response = await fetch("/api/forgot-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      if (response.status === 200) {
        notifyToast({
          message: "Reset password link sent to email",
          type: "success",
        });
      } else if (response.status === 400) {
        notifyToast({
          message: "User does not exist with the given email address",
          type: "error",
        });
      } else {
        notifyToast({
          message: "Unable to sent email",
          type: "error",
        });
      }
    } catch (error) {
      console.log(error);
      notifyToast({ message: "internal server error", type: "error" });
    } finally {
      setIsSpinning(false);
    }
  };

  return (
    <Container>
      <GridRow>
        <GridCell desktop={6} mobile={12}>
          <form id="main-form">
            <Card className="form-container form-card">
              <Message message={message} />
              <div className="login-logo">
                <img src={logo} width="64" />
              </div>
              <div className="mgb-16 xl-bold">Forgot Password</div>
              <input
                onChange={handleChange}
                className="mgb-12"
                required
                type={"email"}
                placeholder={"Email"}
                name="email"
                value={email}
              />
              <SpinnerButton
                isSpinning={isSpinning}
                text={submitText}
                data-analytics={submitText + "click"}
                data-analytics-name={submitText}
                onClick={handleForgotPassword}
              />
            </Card>
          </form>
        </GridCell>
      </GridRow>
    </Container>
  );
};

export default forgotPassword;
